module.exports = __webpack_public_path__ + "img/16581274_L.6c82de5c.png";